import Vue from 'vue'

const isServer = Vue.prototype.$isServer

export function on (el, event, handler, useCapture = false) {
  if (!isServer && document.addEventListener) {
    return (function (el, event, handler) {
      if (el && event && handler) el.addEventListener(event, handler, useCapture)
    }(el, event, handler))
  } else {
    // IE 6 thru 10
    return (function (el, event, handler) {
      if (el && event && handler) el.attachEvent('on' + event, handler)
    }(el, event, handler))
  }
}
export function off (el, event, handler, useCapture = false) {
  if (!isServer && document.removeEventListener) {
    return (function (el, event, handler) {
      if (el && event && handler) el.removeEventListener(event, handler, useCapture)
    }(el, event, handler))
  } else {
    // IE 6 thru 10
    return (function (el, event, handler) {
      if (el && event && handler) el.detachEvent('on' + event, handler)
    }(el, event, handler))
  }
}
export function hasClass (el, cls) {
  if (!el || !cls) return false
  if (!cls) throw new Error('className cannot be empty.')
  if (el.classList) return el.classList.contains(cls)
  return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1
}
export function removeClass (el, cls) {
  if (!el || !cls) return
  if (!cls) throw new Error('className cannot be empty.')
  var curClass = el.className
  var classes = cls.split(' ')
  for (var i = 0; i < classes.length; ++i) {
    var clsName = classes[i]
    if (hasClass(el, clsName)) {
      if (el.classList) el.classList.remove(clsName)
      else {
        if (curClass.indexOf(' ' + clsName + ' ') > -1) curClass = curClass.replace(new RegExp(' ' + clsName + ' '), ' ')
        else if ((curClass.indexOf(' ' + clsName) > -1)) curClass = curClass.replace(new RegExp(' ' + clsName), '')
        else if ((curClass.indexOf(clsName + ' ') > -1)) curClass = curClass.replace(new RegExp(clsName + ' '), '')
        else curClass = curClass.replace(new RegExp(clsName), '')
      }
    }
  }
  if (!el.classList) el.className = curClass
}

export function addClass (el, cls) {
  if (!el || !cls) return
  if (!cls) throw new Error('className cannot be empty.')
  var curClass = el.className
  var classes = cls.split(' ')
  for (var i = 0; i < classes.length; ++i) {
    var clsName = classes[i]
    if (!clsName) continue
    if (!hasClass(el, clsName)) {
      if (el.classList) el.classList.add(clsName)
      else {
        if (!curClass) curClass += clsName // className is empty
        else curClass += ' ' + clsName
      }
    } else continue
  }
  if (!el.classList) el.className = curClass
}
export function toggleClass (el, cls) {
  if (!el || !cls) return
  if (!cls) throw new Error('className cannot be empty.')
  if (hasClass(el, cls)) removeClass(el, cls)
  else addClass(el, cls)
}



// WEBPACK FOOTER //
// ./src/components/framework/utils/dom.js